import { H3, PSmall } from '@components/Typography';

import { Column } from '@components/LinearLayout';
import { CONTACT_FORM_WIDTH } from '@utils/constants';
import styled from 'styled-components';

export const ContactFormRoot = styled(Column)`
  gap: 5rem;
  width: min(${CONTACT_FORM_WIDTH}, 100%);
  margin: auto;
  padding: 7.5rem 0 10rem 0;
  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    padding: 5rem 2rem;
  }
`;

export const ContactApproval = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 5rem;
`;
export const ContactFormBody = styled(Column)`
  gap: 3.4rem;
  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    gap: 2.5rem;
  }
`;

export const FirstLine = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4.3rem;

  & > *:first-child {
    width: auto;
  }

  & > *:not(:first-child) {
    flex: 1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    gap: 2.5rem;

    & > *:first-child {
      width: 100%;
    }

    & > *:not(:first-child) {
      width: 100%;
    }
  }
`;

export const SecondLine = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4.3rem;

  & > *:first-child {
    flex: 1;
  }

  & > *:last-child {
    width: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    gap: 2.5rem;

    & > *:first-child,
    & > *:last-child {
      width: 100%;
    }
  }
`;

export const ThirdLine = styled.div`
  width: 100%;
`;

export const MessageSentRoot = styled(Column)`
  margin: auto;
  padding: 12.5rem 2rem;
  gap: 3.4rem;
`;

export const MessageSentText = styled(H3)`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.size30};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height125};
  color: ${({ theme }) => theme.color.mobilityGrey};
`;

export const CheckboxText = styled(PSmall)`
  font-size: ${({ theme }) => theme.fontSize.size14};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  color: ${({ theme }) => theme.color.mobilityGrey};
`;

export const Captcha = styled.div`
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  border: 0.4rem solid ${({ theme }) => theme.color.strokeGrey};
  width: 30rem;
  height: 8rem;
  background-color: ${({ theme }) => theme.color.white};
`;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.size40};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height115};
  color: ${({ theme }) => theme.color.mobilityGrey};
  @media (max-width: ${({ theme }) => theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
  }
`;
